import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CustomAlertDialogData {
  title?: string;
  message: string;
  buttonText?: string;
}

@Component({
  selector: 'app-custom-alert-dialog',
  templateUrl: './custom-alert-dialog.component.html',
  styleUrls: ['./custom-alert-dialog.component.scss'],
  standalone: false
})
export class CustomAlertDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CustomAlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CustomAlertDialogData
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
